var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1818_3090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5.83759L13.3333 7.82559V6.49959C13.3333 5.96916 13.1226 5.46045 12.7475 5.08538C12.3725 4.71031 11.8638 4.49959 11.3333 4.49959H9.94333L6.61 1.16626H0V2.49959H6.05733L8.05733 4.49959H2C1.46957 4.49959 0.960859 4.71031 0.585786 5.08538C0.210714 5.46045 0 5.96916 0 6.49959L0 16.4996H13.3333V13.1736L16 15.1616V5.83759ZM12 15.1663H1.33333V6.49959C1.33333 6.32278 1.40357 6.15321 1.5286 6.02819C1.65362 5.90316 1.82319 5.83293 2 5.83293H11.3333C11.5101 5.83293 11.6797 5.90316 11.8047 6.02819C11.9298 6.15321 12 6.32278 12 6.49959V15.1663ZM14.6667 12.5043L13.3333 11.5103V9.48893L14.6667 8.49493V12.5043Z",
    fill: "#005C8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1818_3090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetTeam);
export default __webpack_public_path__ + "static/media/meet-team.07dc551a4c62a9a6a685e7d6ff51b603.svg";
export { ForwardRef as ReactComponent };